import React from "react"
import PropTypes from "prop-types"
import { FaPlayCircle } from "react-icons/fa" // Add your chosen icon here
import "./style-youtube-container.css"

const YoutubeContainer = ({ youtubeLink }) => {
  return (
    <div className="youtube-container">
      <FaPlayCircle className="youtube-play-icon" />
      <iframe
        src={`https://www.youtube.com/embed/${youtubeLink}`}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  )
}

YoutubeContainer.propTypes = {
  youtubeLink: PropTypes.string,
}

YoutubeContainer.defaultProps = {
  youtubeLink: "dQw4w9WgXcQ", // This is a sample YouTube video ID. Please replace with your actual YouTube video ID.
}

export default YoutubeContainer
